export function prefetchScript(urlToPrefetch: string) {
  const prefetchTag = document.createElement('link');
  prefetchTag.as = 'script';
  prefetchTag.rel = 'prefetch';
  prefetchTag.href = urlToPrefetch;
  prefetchTag.crossOrigin = 'anonymous';
  document.head.appendChild(prefetchTag);
}
